<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data Emissão Inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data Emissão Final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              class="rounded-tag-small"
              dense
              search-in-compra
              search-by-codigo-interno
              v-model="localFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch dense
                      hide-details
                      class="pa-0 mt-2 mr-2"
                      label="Apenas sem vínculo"
                      color="primary"
                      v-model="localNotasSemVinculo"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localDataInicial: null,
    localDataFinal: null,
    localEmpresa: null,
    localFornecedor: [],
    localNotasSemVinculo: false,
  }),
  computed: {
    ...mapGetters('listagemNotasFiscais', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    icon() {
      return this.hasCustomFilters ? 'mdi-filter' : 'mdi-filter-outline';
    },
    empresa: {
      get() {
        return this.$store.getters['listagemNotasFiscais/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('listagemNotasFiscais/empresa', empresa);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['listagemNotasFiscais/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('listagemNotasFiscais/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['listagemNotasFiscais/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('listagemNotasFiscais/dataInicial', dataInicial);
      },
    },
    fornecedor: {
      get() {
        return this.$store.getters['listagemNotasFiscais/fornecedor'];
      },
      set(fornecedor) {
        this.$store.dispatch('listagemNotasFiscais/fornecedor', fornecedor);
      },
    },
    notasSemVinculo: {
      get() {
        return this.$store.getters['listagemNotasFiscais/notasSemVinculo'];
      },
      set(notasSemVinculo) {
        this.$store.dispatch('listagemNotasFiscais/notasSemVinculo', notasSemVinculo);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.dataFinal = this.localDataFinal;
      this.dataInicial = this.localDataInicial;
      this.fornecedor = this.localFornecedor;
      this.notasSemVinculo = this.localNotasSemVinculo;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localDataFinal = null;
      this.localDataInicial = null;
      this.localFornecedor = [];
      this.localNotasSemVinculo = false;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localDataFinal = this.dataFinal || null;
    this.localDataInicial = this.dataInicial || null;
    this.localFornecedor = this.fornecedor || [];
    this.localNotasSemVinculo = this.localNotasSemVinculo ?? false;
  },
};
</script>
